import updateCart from './update-popup-cart.js';
import { postData } from './fetch';

window.addEventListener('load', () => {
  const productConsistItems = document.querySelectorAll(
    '.product-consist-item',
  );
  const productPopupCountButton = document.querySelectorAll(
    '.product-popup-wrapper .count-button',
  );
  const productVariants = document.querySelectorAll('.variant');
  const buyButtons = document.querySelectorAll('.buy-button');
  const productPopupBuyWrapper = document.querySelectorAll(
    '.product-popup-wrapper .buy-wrapper',
  );
  const treasureBuyButton = document.querySelector('.treasure-buy-button');
  const treasureModifierInput = document.querySelectorAll(
    '.treasure-modifier-input',
  );
  const relatedProductsSwiper = document.querySelector(
    '.related-products-swiper',
  );
  const productConsistSwiper = document.querySelector(
    '.product-consist-swiper',
  );
  const closePopup = document.querySelector('.product-popup .close-popup');
  const countInputs = document.querySelectorAll('.product-popup .count-input');
  const popupOverlay = document.querySelector('.popup-overlay');
  const productPopup = document.querySelector('.product-popup');
  const successPopup = document.querySelector('.success-popup');

  if (treasureModifierInput) {
    [].forEach.call(treasureModifierInput, (input) => {
      input.addEventListener('click', () => {
        const parentElement = input.closest('.treasure-popup-wrapper');

        if (parentElement) {
          const buyButton = parentElement.querySelector('.treasure-buy-button');

          if (buyButton) {
            buyButton.dataset.groupid = input.dataset.groupid;
            buyButton.dataset.modifierid = input.value;

            buyButton.classList.remove('disabled');
          }
        }
      });
    });
  }

  if (treasureBuyButton) {
    treasureBuyButton.addEventListener('click', async () => {
      const groupId = treasureBuyButton.dataset.groupid;
      const modifierId = treasureBuyButton.dataset.modifierid;
      const popupWrapper = treasureBuyButton.closest('.treasure-popup-wrapper');

      const modifiers = [
        {
          groupId,
          items: [
            {
              id: modifierId,
              quantity: 1,
            },
          ],
        },
      ];

      const body = {
        id: treasureBuyButton.dataset.id,
        quantity: 1,
        modifiers: JSON.stringify(modifiers),
      };

      treasureBuyButton.textContent = 'Загрузка...';
      treasureBuyButton.classList.add('disabled');

      const { price } = treasureBuyButton.dataset;

      const response = await postData('/cart', body);

      if (response) {
        if (response.statusCode === 200) {
          treasureBuyButton.textContent = `В корзину за ${price} ₽`;
          treasureBuyButton.dataset.groupid = '';
          treasureBuyButton.dataset.modifierid = '';

          if (productPopup) {
            productPopup.classList.add('hidden');
          }

          if (successPopup) {
            successPopup.classList.add('visible');

            setTimeout(() => {
              successPopup.classList.remove('visible');
              popupWrapper.classList.remove('active');
              productPopup.classList.remove('hidden');

              if (treasureModifierInput) {
                [].forEach.call(
                  treasureModifierInput,
                  (input) => (input.checked = false),
                );
              }
            }, 2000);
          }

          updateCart(response.data, response.data.additional);
        } else {
          treasureBuyButton.classList.remove('disabled');
          treasureBuyButton.textContent = `В корзину за ${price} ₽`;
        }
      }
    });
  }

  if (productVariants) {
    [].forEach.call(productVariants, (input) => {
      input.addEventListener('change', () => {
        const { id } = input.dataset;
        const productDescription = document.querySelectorAll(
          '.product-name span',
        );
        const productChildrenWrappers = document.querySelectorAll(
          '.children-image-wrapper',
        );

        if (productDescription) {
          [].forEach.call(productDescription, (item) =>
            item.classList.remove('visible'),
          );
        }

        if (productPopupBuyWrapper) {
          [].forEach.call(productPopupBuyWrapper, (wrapper) =>
            wrapper.classList.remove('visible'),
          );
        }

        if (productChildrenWrappers) {
          [].forEach.call(productChildrenWrappers, (wrapper) =>
            wrapper.classList.remove('visible'),
          );
        }

        if (document.getElementById(`image-${id}`)) {
          document.getElementById(`image-${id}`).classList.add('visible');
        }

        if (
          document.querySelector(
            `.product-popup-wrapper .buy-wrapper[data-id="${id}"]`,
          )
        ) {
          document
            .querySelector(
              `.product-popup-wrapper .buy-wrapper[data-id="${id}"]`,
            )
            .classList.add('visible');
        }

        if (document.querySelector(`.product-name span[data-id="${id}"]`)) {
          document
            .querySelector(`.product-name span[data-id="${id}"]`)
            .classList.add('visible');
        }
      });
    });
  }

  if (productPopupCountButton) {
    [].forEach.call(productPopupCountButton, (wrapper) => {
      const countInput = wrapper.querySelector('.count-input');
      const buttonPlus = wrapper.querySelector('.plus');
      const buttonMinus = wrapper.querySelector('.minus');
      const productId = wrapper.dataset.id;

      if (buttonPlus) {
        buttonPlus.addEventListener('click', () => {
          const buyButton = document.querySelector(
            `.buy-button[data-id="${productId}"]`,
          );
          let realProductQuantity = countInput.dataset.quantity;

          const price = parseInt(buyButton.dataset.price, 10);
          const priceString = buyButton.querySelector('span');

          realProductQuantity++;

          countInput.dataset.quantity = realProductQuantity;
          countInput.value = parseInt(countInput.value, 10) + 1;

          if (parseInt(countInput.value, 10) > 1) {
            buttonMinus.classList.remove('disabled');
          }

          if (
            parseInt(countInput.value, 10) === 99 ||
            realProductQuantity == 98
          ) {
            buttonPlus.classList.add('disabled');
          }

          if (priceString) {
            priceString.textContent = price * parseInt(countInput.value, 10);
          }
        });
      }

      if (buttonMinus) {
        buttonMinus.addEventListener('click', () => {
          const buyButton = document.querySelector(
            `.buy-button[data-id="${productId}"]`,
          );
          let realProductQuantity = countInput.dataset.quantity;

          const price = parseInt(buyButton.dataset.price, 10);
          const priceString = buyButton.querySelector('span');

          if (parseInt(countInput.value, 10) > 1) {
            realProductQuantity--;

            countInput.dataset.quantity = realProductQuantity;
            countInput.value = parseInt(countInput.value, 10) - 1;
          }

          if (parseInt(countInput.value, 10) === 1) {
            buttonMinus.classList.add('disabled');
          }

          if (
            (parseInt(countInput.value, 10) < 99 || realProductQuantity < 98) &&
            buttonPlus.classList.contains('disabled')
          ) {
            buttonPlus.classList.remove('disabled');
          }

          if (priceString) {
            priceString.textContent = price * parseInt(countInput.value, 10);
          }
        });
      }
    });
  }

  if (closePopup) {
    closePopup.addEventListener('click', () => {
      if (buyButtons) {
        [].forEach.call(buyButtons, (btn) => {
          if (!btn.classList.contains('non-removed')) {
            btn.classList.remove('product-added');

            if (btn.dataset.stoplist) {
              btn.textContent = 'Недоступно';
            } else {
              btn.innerHTML = `В корзину за <span>${btn.dataset.price}</span> ₽`;
            }
          }
        });
      }

      if (countInputs) {
        [].forEach.call(countInputs, (input) => {
          input.value = 1;

          const parentElement = input.closest('.count-button');

          if (parentElement) {
            const buttonMinus = parentElement.querySelector('.minus');
            const buttonPlus = parentElement.querySelector('.plus');

            if (buttonMinus) {
              buttonMinus.classList.add('disabled');
            }

            if (buttonPlus) {
              buttonPlus.classList.remove('disabled');
            }
          }
        });
      }

      if (productPopupBuyWrapper) {
        [].forEach.call(productPopupBuyWrapper, (wrapper) =>
          wrapper.classList.remove('visible'),
        );
      }

      if (productPopupBuyWrapper[0]) {
        productPopupBuyWrapper[0].classList.add('visible');
      }

      if (productVariants[0]) {
        productVariants[0].checked = true;
      }
    });
  }

  if (popupOverlay) {
    popupOverlay.addEventListener('click', () => {
      if (buyButtons) {
        [].forEach.call(buyButtons, (btn) => {
          if (!btn.classList.contains('non-removed')) {
            btn.classList.remove('product-added');
            btn.innerHTML = `В корзину за <span>${btn.dataset.price}</span> ₽`;
          }
        });
      }

      if (countInputs) {
        [].forEach.call(countInputs, (input) => {
          input.value = 1;

          const parentElement = input.closest('.count-button');

          if (parentElement) {
            const buttonMinus = parentElement.querySelector('.minus');
            const buttonPlus = parentElement.querySelector('.plus');

            if (buttonMinus) {
              buttonMinus.classList.add('disabled');
            }

            if (buttonPlus) {
              buttonPlus.classList.remove('disabled');
            }
          }
        });
      }

      if (productPopupBuyWrapper) {
        [].forEach.call(productPopupBuyWrapper, (wrapper) =>
          wrapper.classList.remove('visible'),
        );
      }

      if (productPopupBuyWrapper[0]) {
        productPopupBuyWrapper[0].classList.add('visible');
      }

      if (productVariants[0]) {
        productVariants[0].checked = true;
      }
    });
  }

  if (relatedProductsSwiper) {
    new Swiper('.related-products-swiper', {
      slidesPerView: 1.3,
      spaceBetween: 10,
      breakpoints: {
        450: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 3,
        },
        900: {
          slidesPerView: 4,
        },
        1060: {
          slidesPerView: 5,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  if (productConsistSwiper) {
    new Swiper('.product-consist-swiper', {
      slidesPerView: 1.7,
      spaceBetween: 30,
      loop: false,
      breakpoints: {
        450: {
          slidesPerView: 3,
        },
        900: {
          slidesPerView: productConsistItems.length,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
});
